import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../../apis/transform/stats"
import style from "./style.module.scss"
import Image from "next/image"
import gol from "@assets/icons/players/Gol.svg"
import minuti from "@assets/icons/players/Minuti.svg"
import parate from "@assets/icons/players/Parate.svg"
import errori from "@assets/icons/players/Errori.svg"

export function PlayerMinutesGoalkeeper({
  minutes,
  saves,
  concededGoals,
  savedPenalties,
  ducks,
}: {
  minutes: number
  saves: number
  concededGoals: number
  savedPenalties?: number
  ducks: number
}) {
  return (
    <Row className={style.firstRow}>
      <Col className={style.element} xs={6} sm={6} md={6} lg={3} xl={3}>
        <dl>
          <dt className={style.icon}>
            <Image src={minuti} width={36} height={43} alt="matches" />
          </dt>
          <div className={style.data}>
            <dt className={style.label}>Minuti giocati</dt>
            <dd className={style.value}>{statNumberToString(minutes)}</dd>
          </div>
        </dl>
      </Col>
      <Col className={style.element} xs={6} sm={6} md={6} lg={3} xl={3}>
        <dl>
          <dt className={style.icon}>
            <Image src={parate} width={48} height={32} alt="goals" />
          </dt>
          <div className={style.data}>
            <dt className={style.label}>Parate</dt>
            <dd className={style.value}>{statNumberToString(saves)}</dd>
          </div>
        </dl>
      </Col>
      <Col className={style.element} xs={6} sm={6} md={6} lg={3} xl={3}>
        <dl>
          <dt className={style.icon}>
            <Image src={gol} width={42} height={42} alt="fouls" />
          </dt>
          <div className={style.data}>
            <dt className={style.label}>Gol subiti</dt>
            <dd className={style.value}>{statNumberToString(concededGoals)}</dd>
          </div>
        </dl>
      </Col>
      <Col className={style.element} xs={6} sm={6} md={6} lg={3} xl={3}>
        <dl>
          <dt className={style.icon}>
            <Image src={errori} width={40} height={41} alt="fouls" />
          </dt>
          <div className={style.data}>
            <dt className={style.label}>{savedPenalties ? "Rigori parati" : "Errori gravi"}</dt>
            <dd className={style.value}>{statNumberToString(savedPenalties ? savedPenalties : ducks)}</dd>
          </div>
        </dl>
      </Col>
    </Row>
  )
}
